<template>
  <div class="page-base-container" :style="{minWidth:pageMiniWidth+'px'}">
    <div class="nav1">
      <div class="left">
        <div class="item tran-all"
             :class="[index==index1?'active':'',index!==index1&&(index+1)!=index1?'has-border':'']"
             @click="clickFirst(index)" v-for="(item,index) in navigation" :key="index">
          <span class="zsf-icon" :class="item.icon"></span>
          <b>{{item.name}}</b>
        </div>
      </div>
      <div class="right">
        <div>
          <span class="zsf-icon zsf-icon-touxiang"></span>
          <span class="ml-3">张三丰</span>
        </div>
        <div @click="quit" class="c-pointer">
          <span class="zsf-icon zsf-icon-tuichu"></span>
          <span class="ml-3">退出</span>
        </div>
      </div>
    </div>
    <div class="nav2">
      <div class="left">
        <div class="item tran-all" :class="index==index2?'active':''" @click="clickSecond(index)"
             v-for="(item,index) in navigation[index1].child" :key="index">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="right">
        <div class="search">
          <el-input type="primary" placeholder="搜索人员查看位置"
                    v-model="person" class="input" size="mini">
            <el-button type="primary" style="padding:12px;" slot="append"
                       @click="search" icon="el-icon-search"></el-button>
          </el-input>
          <div class="search-result tran-all" v-if="personIsShow">
            <div class="item" @click="selectOnePerson(index)"
                 v-for="(item,index) in personList" :key="index">{{item.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-base-box">
      <keep-alive>
        <router-view>
          <slot @showRadio="showRadio"></slot>
        </router-view>
      </keep-alive>
    </div>
    <div class="footer">
      <img src="../../common/images/logo.png"/>
    </div>

    <el-dialog title="广播" width="800px" :visible.sync="unlockIsShow">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="播语音" name="first">
          <div class="auth-box111">
            <div class="item" :class="item.active?'active':''" @click="setActive(index)"
                 v-for="(item,index) in allBaseStations" :key="index">
              <span class="width-100 t-hidden">{{item.id}}</span>
              <span class="width-150 color-999 ml-10">{{item.name}}</span>
              <span class="color-999 ml-10">其他字段</span>
            </div>
          </div>
          <div class="pagination pt-10 t-center mt-10">
            <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                           :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                           :current-page.sync="pagination.page"
                           :total="pagination.total"
                           @size-change="changeSize"
                           @current-change="changeCurrent"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="语音呼叫" name="second">
          <el-select style="width:100%;" v-model="value1" multiple placeholder="请选择">
            <el-option v-for="item in ['张1丰','张2丰','张3丰','张4丰']"
                       :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="unlockIsShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAuth">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {mapGetters, mapMutations} from "vuex";
  import {navigation, prejuctConfig} from "../../config.js";
  import {tool} from "../../common/js/tool.js";
  export default {
    data() {
      return {
        navigation: navigation,
        index1: 0,
        index2: 0,
        person: "",
        active: "",
        unlockIsShow: false,
        activeName: 'first',
        hasBaseStationIds: [1, 2, 8],
        allBaseStations: [],
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        value1: '',
        pageMiniWidth: prejuctConfig.pageMiniWidth,
        personList: [
          {name: '张一丰', card: 'S18176', id: 1},
          {name: '张二丰', card: 'S18159', id: 2},
          {name: '张三丰', card: 'S18202', id: 3},
          {name: '张四丰', card: 'S18203', id: 4}
        ],
        personIsShow: false
      };
    },

    computed: {
      getTabs() {
        return this.$store.getters.getTabs;
      },
      getTabActive() {
        return this.$store.getters.getTabActive;
      }
    },

    created() {
      this.active = this.$store.getters.getTabActive;
      let u = this.$route.query.u;
      let hash = window.location.hash.replace("#", "");
      hash = !!u ? u : hash;
      // console.log(hash);
      let tmp = [...this.navigation];
      for (let i = 0; i < tmp.length; i++) {
        for (let j = 0; j < tmp[i]["child"].length; j++) {
          if (hash === tmp[i]["child"][j]["url"]) {
            //console.log(i, j);
            let xTabs = this.$store.getters.getTabs;
            xTabs[0]["active"] = false;
            xTabs.push({
              name: tmp[i]["child"][j]["name"],
              index1: i,
              index2: j,
              url: tmp[i]["child"][j]["url"],
              active: true
            });
            if (xTabs[0]["url"] !== tmp[i]["child"][j]["url"]) {
              this.$store.commit("setTabs", xTabs);
              this.$store.commit("setTabActive", i + "-" + j);
              this.index1 = i;
              this.index2 = j;
            }
            break;
          }
        }
      }
    },

    mounted() {
      this.$on("showRadio", this.showRadio);  // 在mounted生命周期注册事件
      let list = [];
      for (let i = 1; i < 11; i++) {
        list.push({id: i, name: '语音文件' + i});
      }
      this.list = list;
      this.allBaseStations = list;
    },

    methods: {
      search() {
        this.personIsShow = true;
      },

      selectOnePerson(index){
        this.personIsShow = false;
        if (this.$route.query.id !== this.personList[index].id) {
          this.$router.push({
            path: '/monitoring/realtime',
            query: {id: this.personList[index].id, name: this.personList[index].name}
          });
        }
      },

      setActive(index){
        this.unlockIsShow = false;
        alert('如果不是超级管理员，判断喇叭是否可用；如果是超管，中断喇叭；播放语音文件' + index);
      },
      showRadio(aaa){
        console.error(aaa);
        this.activeName = 'first';
        this.unlockIsShow = true;
      },
      submitAuth(){
        this.unlockIsShow = false;
      },
      handleClick(tab, event){
        //console.log(tab, event);
        if (tab.index == 1) {
          this.unlockIsShow = false;
          alert('如果不是超级管理员，判断喇叭是否可用；如果是超管，中断喇叭；语音呼叫');
        }
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
      },

      clickFirst(index) {
        this.index1 = index;
        this.index2 = 0;
        this.gotoPage();
      },
      clickSecond(index) {
        this.index2 = index;
        this.gotoPage();
      },
      gotoPage() {
        let index1 = this.index1;
        let index2 = this.index2;
        let tmp = [...this.navigation];
        let type = tmp[index1].child[index2].type;
        //console.log(index1, index2);
        //console.log(this.$route.query.in);
        switch (type) {
          case "allShipWarning":
            this.allShipWarning();
            break;
          case "allShipRadio":
            //this.allShipRadio();
            this.showRadio();
            break;
          case "voiceCalls":
            this.voiceCalls();
            break;
          default:
            let url = tmp[index1]["child"][index2]["url"];
            console.log(url);
            let index = index1 + "-" + index2;
            let xTabs = this.$store.getters.getTabs;
            let xActive = this.$store.getters.getTabActive;
            this.$store.commit("setTabActive", index);
            let flag = true;
            for (let i = 0; i < xTabs.length; i++) {
              if (index === xTabs[i].index1 + "-" + xTabs[i].index2) {
                flag = false;
                break;
              }
            }
            if (flag) {
              for (let i = 0; i < xTabs.length; i++) {
                xTabs[i]["active"] = false;
              }
              xTabs.push({
                pageMenu: tmp[index1]["child"][index2]["name"],
                index1: index1,
                index2: index2,
                pageUrl: url,
                active: true
              });
              this.$store.commit("setTabs", xTabs);
              this.$router.push({path: url});
            } else {
              for (let i = 0; i < xTabs.length; i++) {
                if (xTabs[i].index1 === index1 && xTabs[i].index2 === index2) {
                  xTabs[i].active = true;
                } else {
                  xTabs[i].active = false;
                }
              }
              console.log(index, xActive)
              if (index !== xActive || this.$route.query.in) {
                this.$router.push({path: url});
              }
            }
        }
      },

      allShipRadio() {
        this.$confirm("确定要全船广播吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          alert("如果不是超级管理员，先查询喇叭是否全部可用；如果不超管，中断所有在播的喇叭；调用全船广播接口");
        });
      },
      allShipWarning() {
        this.$confirm("确定要全船发送紧急告警吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          alert("调用全船紧急告警的接口");
        });
      },
      voiceCalls() {
        this.$confirm("确定要语音呼叫吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          alert("调用语音呼叫接口");
        });
      },
      quit() {
        this.$confirm("确定要退出吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$router.push({path: "/login"});
        });
      }
    },

    components: {},

    watch: {
      $route: function (old, newVal) {
        if (old !== newVal) {
          this.personIsShow = false;
        }
      }
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import url("../../common/less/variable.less");

  .page-base-container {
    width: 100%;
    /*min-width: 1360px;*/
    height: 100%;
    background: #e6e8ef;
    padding: 15px;
    overflow-y: auto;
    .nav1 {
      display: flex;
      height: 44px;
      align-items: stretch;
      .left {
        flex: 1;
        display: flex;
        align-items: stretch;
        .item {
          color: #70789d;
          width: 105px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          cursor: pointer;
          font-size: 16px;
          span {
            margin-right: 2px;
            font-size: 20px;
          }
          &:hover {
            color: #30417a;
            font-weight: 600;
          }
          &.active {
            background: @colorHeader;
            border-radius: 10px 10px 0 0;
            color: white;
            font-weight: 600;
            &:before {
              background: none;
            }
          }
          &.has-border {
            &:before {
              display: block;
              content: "";
              width: 1px;
              height: 20px;
              position: absolute;
              right: 0;
              top: 12px;
              background: #70789d;
            }
          }
          &:last-child {
            &:before {
              background: none;
            }
          }
        }
      }
      .right {
        display: flex;
        justify-content: center;
        color: #3b3b3b;
        align-items: stretch;
        font-size: 12px;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
        }
      }
    }
    .nav2 {
      width: 100%;
      height: 36px;
      background: @colorHeader;
      border-radius: 0 10px 0 0;
      padding: 0 15px 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      .left {
        display: flex;
        align-items: stretch;
        height: 36px;
        .item {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          float: left;
          margin-right: 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          span {
            height: 14px;
            border-right: 1px solid rgba(255, 255, 255, 0.8);
            padding-right: 10px;
          }
          &:last-child {
            span {
              border-right: none;
            }
          }
          &:hover,
          &.active {
            color: white;
            span {
              font-weight: bold;
            }
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .search {
          /*position: absolute;*/
          z-index: 10;
          /*left: 15px;*/
          /*top: 15px;*/
          .input {
            width: 200px;
            .el-input__inner {
              padding: 0 10px;
            }
          }
        }
        .search-result {
          width: 200px;
          height: 300px;
          background: white;
          position: absolute;
          left: 0;
          top: 36px;
          box-shadow: 0 0 20px #eee;
          padding: 10px 0;
          .item {
            width: 200px;
            height: 35px;
            line-height: 35px;
            padding-left: 10px;
            &:hover {
              background: #eaeaea;
            }
          }
        }
      }
    }
    .page-base-box {
      width: 100%;
      height: auto;
      background: rgba(247, 247, 247, 1);
      box-shadow: 0px -5px 19px 0px rgba(155, 168, 227, 0.24);
      border-radius: 0 0 10px 10px;
    }
    .footer {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 300px;
      }
    }
  }

  .auth-box111 {
    font-size: 13px;
    height: 400px;
    overflow-y: auto;
    border-top: 1px solid #dcdcdc;
    .item {
      height: 45px;
      line-height: 45px;
      padding: 0 20px;
      border-bottom: 1px solid #dcdcdc;
      span {
        height: 45px;
        line-height: 45px;
        display: block;
        float: left;
      }
      &.active {
        background: #f9f9f9;
      }
      .check {
        display: inline-block;
        width: 30px;
      }
      .color-409eff {
        color: #409eff;
      }
      .color-dcdcdc {
        color: #dcdcdc;
      }
    }
  }
</style>
